import styled from "styled-components";

export const StyledBondDelivery = styled.section`
  display: flex !important;
  flex-direction: column;
`;

export const StyledSpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -25px;
`;

export const StyledBondDeliveryHeader = styled.header``;

export const StyledBondDeliveryField = styled.div`
  margin-bottom: 24px;
`;

export const StyledBondDeliveryLabel = styled.p`
  font-size: 16px;
  color: #000000;
  font-weight: 400;
  margin-bottom: 24px !important;
  line-height: 27px;
`;

export const StyledBondDeliveryButton = styled.button`
  width: 100%;
  font-size: 18px;
  color: white;
  border-radius: 5px !important;
  background-color: var(--primary);
  text-transform: uppercase !important;
  padding: 16px 0;
  line-height: 18px;
  font-family: "Inter" !important;

  &:disabled {
    opacity: 0.65;
  }
`;

export const StyledBondDeliveryText = styled.p`
  width: 100%;
  font-size: 16px;
  font-family: Roboto;
  font-weight: bold;
  line-height: 27px;
  font-style: normal;
  text-align: left;
  color: #000000;
`;
